"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_hyperlink_1 = __importDefault(require("react-native-hyperlink"));
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const config_1 = require("../../../../web/firebase/config");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const IconComment_1 = __importDefault(require("../../../assets/icons/IconComment"));
const IconLike_1 = __importDefault(require("../../../assets/icons/IconLike"));
const IconReset_1 = __importDefault(require("../../../assets/icons/IconReset"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const IconLike_2 = __importDefault(require("../../../components/Icon/IconLike"));
const IconRetweet_1 = __importDefault(require("../../../components/Icon/IconRetweet"));
const IconThreeDoc_1 = __importDefault(require("../../../components/Icon/IconThreeDoc"));
const ModalHistoryLike_1 = __importDefault(require("../../../components/modal/ModalHistoryLike"));
const ModalReportReason_1 = __importDefault(require("../../../components/modal/ModalReportReason"));
const ModalReportSuccess_1 = __importDefault(require("../../../components/modal/ModalReportSuccess"));
const ModalShare_1 = __importDefault(require("../../../components/modal/ModalShare"));
const ModalSuccess_1 = __importDefault(require("../../../components/modal/ModalSuccess"));
const skeletons_1 = require("../../../components/skeletons");
const Status_1 = require("../../../components/status/Status");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const LinkErrorScreen_1 = __importDefault(require("../../../components/warningscreen/LinkErrorScreen"));
const constants_1 = require("../../../constants");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const apis_1 = require("../../../networking/apis");
const helpler_1 = require("../../../utils/helpler");
const mockData_1 = require("../../../utils/mockData");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const BlockedView_1 = __importDefault(require("../components/BlockedView"));
const ItemUser_1 = __importDefault(require("../components/ItemUser"));
const ListImageItemDetail_1 = __importDefault(require("../components/ListImageItemDetail"));
const QuoteTweet_1 = __importDefault(require("../components/QuoteTweet"));
const styles_1 = __importDefault(require("./styles"));
const DetailHomeScreen = (props) => {
    const { postId, first = false } = props.route.params;
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const firebaseUser = (0, react_redux_1.useSelector)((state) => state.loginFirebaseReducer.user);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const dataListFollow = (0, react_redux_1.useSelector)((state) => state?.listFollowReducer?.listFollow, react_redux_1.shallowEqual);
    const dataListBlock = (0, react_redux_1.useSelector)((state) => state?.listBlockReducer.listBlock, react_redux_1.shallowEqual);
    const [tweet, setTweet] = (0, react_1.useState)();
    const [replies, setReplies] = (0, react_1.useState)([]);
    const [visibleLike, setVisibleLike] = (0, react_1.useState)(false);
    const [visibleModalSuccess, setVisibleModalSuccess] = (0, react_1.useState)(false);
    const [visibleModal, setVisibleModal] = (0, react_1.useState)(false);
    const [isAlert, setIsAlert] = (0, react_1.useState)(false);
    const [visibleReport, setVisibleReport] = (0, react_1.useState)(false);
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    const [countLike, setCountLike] = (0, react_1.useState)(0);
    const [pathQuote, setPathQuote] = (0, react_1.useState)('');
    const [idQuote, setIdQuote] = (0, react_1.useState)('');
    const [dataquoteTweetPadh, setDataquoteTweetPadh] = (0, react_1.useState)('');
    const [hasAccessPermission, setAccessPermission] = (0, react_1.useState)(true);
    const refIsCallingAPI = (0, react_1.useRef)(false);
    const refListFollow = (0, react_1.useRef)([]);
    const isAnonymous = dataUser?.registration_status == 0;
    const firestorePath = () => {
        const pathParam = `tweets/${decodeURIComponent(postId || '')}`;
        if (pathParam?.includes('replies')) {
            let containsReplies = pathParam?.indexOf('replies') != -1;
            let textAfterSlash = null;
            let textpath = null;
            if (containsReplies) {
                textpath = pathParam?.slice(0, pathParam?.lastIndexOf('replies') + 7);
                textAfterSlash = pathParam?.slice(pathParam?.lastIndexOf('replies') + 8);
            }
            return textpath;
        }
        return 'tweets';
    };
    const idPostTweets = () => {
        const pathParam = `tweets/${decodeURIComponent(postId || '')}`;
        if (pathParam?.includes('replies')) {
            let containsReplies = pathParam?.indexOf('replies') != -1;
            let textAfterSlash = '';
            let textpath = null;
            if (containsReplies) {
                textpath = pathParam?.slice(0, pathParam?.lastIndexOf('replies') + 7);
                textAfterSlash = pathParam?.slice(pathParam?.lastIndexOf('replies') + 8);
            }
            return textAfterSlash;
        }
        return postId || '';
    };
    (0, react_1.useEffect)(() => {
        if (connected) {
            if (!firebaseUser?.uid || !postId || !idPostTweets()) {
                return;
            }
            setLoading(true);
            try {
                config_1.firebase
                    .firestore()
                    .collection(firestorePath() || 'tweets')
                    .doc(idPostTweets())
                    .onSnapshot((querySnapshot) => {
                    const data = querySnapshot.data();
                    if (data) {
                        data.tweetId = idPostTweets();
                        if (data?.type == 3) {
                            const path = data?.quoteTweetPath;
                            let containsReplies = path?.indexOf('replies') != -1;
                            let parts = '';
                            let textAfterSlash = null;
                            let textpath = null;
                            if (containsReplies) {
                                textpath = path?.slice(0, path?.lastIndexOf('replies') + 7);
                                textAfterSlash = path?.slice(path?.lastIndexOf('replies') + 8);
                            }
                            else {
                                parts = path.split('/');
                                textAfterSlash = parts[1];
                            }
                            setIdQuote(textAfterSlash);
                            setPathQuote(textpath);
                            config_1.firebase
                                .firestore()
                                .collection(textpath ? textpath : firestorePath())
                                .doc(textAfterSlash)
                                .get()
                                .then((res) => {
                                setDataquoteTweetPadh(res.data());
                            })
                                .catch((_err) => { });
                        }
                        checkAccessPermission(data, () => {
                            setLoading(false);
                            setTweet(data);
                            setCountLike(data.likes);
                        });
                    }
                });
            }
            catch {
                ;
                (_err) => {
                    setLoading(false);
                };
            }
            try {
                config_1.firebase
                    .firestore()
                    .collection(firestorePath() || 'tweets')
                    .doc(idPostTweets())
                    .collection('replies')
                    .orderBy('createdAt', 'desc')
                    .onSnapshot((querySnapshot) => {
                    const data = [];
                    querySnapshot.forEach((doc) => {
                        data.push({ ...doc.data(), _id: doc.id });
                    });
                    setReplies(data);
                });
            }
            catch {
                ;
                (_err) => { };
            }
        }
    }, [firebaseUser, postId, connected]);
    (0, react_1.useEffect)(() => {
        refListFollow.current = dataListFollow;
        if (!!tweet) {
            if (tweet?.type == 1
                &&
                    tweet?.publicationRange == 1
                &&
                    dataUser?.user_id != tweet.userId
                &&
                    !dataListFollow.includes(`${tweet.userId}`)) {
                setAccessPermission(false);
            }
            else {
                setAccessPermission(true);
            }
        }
    }, [dataListFollow, tweet]);
    (0, react_1.useEffect)(() => {
        if (dataUser?.user_id && tweet) {
            checkAccessPermission(tweet, () => { });
        }
    }, [dataUser?.user_id, tweet?._id]);
    (0, react_1.useEffect)(() => {
        if (!hasAccessPermission && isAnonymous && !first) {
            dispatch(slice_1.default.actions.showRequestLoginModal());
        }
    }, [hasAccessPermission]);
    const checkAccessPermission = async (_tweet, callback) => {
        if (!!_tweet) {
            if (_tweet?.type == 1
                &&
                    _tweet?.publicationRange == 1
                &&
                    dataUser?.user_id != _tweet.userId
                &&
                    !refListFollow.current.includes(`${_tweet.userId}`)) {
                setAccessPermission(false);
                callback();
            }
            else if (!!dataUser?.user_id) {
                config_1.firebase
                    .firestore()
                    .collection('users')
                    .doc(_tweet?.userId.toString())
                    .collection('blockUsers')
                    .get()
                    .then((blockList) => {
                    const isBlocked = blockList.docs.some((data) => data.id == dataUser?.user_id);
                    if (isBlocked) {
                        (0, rootNavigation_1.replace)(Routes_1.default.URL_NOT_FOUND);
                    }
                })
                    .catch(() => { })
                    .finally(callback);
            }
            else {
                callback();
            }
        }
    };
    const displayTweet = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HOME);
    };
    const navigateToUserProfile = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: tweet?.userHandle,
            },
        });
    };
    const handleFollowUser = () => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingAPI.current)
            return;
        refIsCallingAPI.current = true;
        apis_1.BasicApi.followUser(tweet?.userId)
            .then(() => {
            dispatch(slice_1.default.actions.showToast(`${tweet?.nickname || constants_1.DEFAULT_NAME}さんをフォローしました`));
        })
            .catch((_err) => { })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    if (dataListBlock.includes(`${tweet?.userId}`)) {
        return react_1.default.createElement(BlockedView_1.default, { tweet: tweet });
    }
    return (react_1.default.createElement(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
        } },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: 'タイムライン', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#21242D' }), onLeftPress: rootNavigation_1.goBack }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.container }, isLoading ? (react_1.default.createElement(skeletons_1.PostSkeleton, null)) : tweet ? (react_1.default.createElement(react_native_1.ScrollView, { showsVerticalScrollIndicator: false, contentContainerStyle: {
                paddingBottom: inset.bottom + (0, scale_1.scale)(130),
                paddingTop: (0, scale_1.scale)(24),
            } },
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginBottom: (0, scale_1.scale)(12),
                    paddingHorizontal: (0, scale_1.scale)(16),
                } },
                react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
                    react_1.default.createElement(react_native_1.Image, { source: tweet?.thumbnailUrl
                            ? { uri: tweet.thumbnailUrl }
                            : images_1.images.AvatarDefaul, style: {
                            height: (0, scale_1.scale)(42),
                            width: (0, scale_1.scale)(42),
                            borderRadius: 999,
                            paddingRight: (0, scale_1.scale)(12),
                        } })),
                react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(240), justifyContent: 'center' } },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            color: '#292A33',
                        }, onPress: navigateToUserProfile }, tweet?.nickname || constants_1.DEFAULT_NAME),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(10),
                            lineHeight: (0, scale_1.moderateScale)(17),
                            fontWeight: '300',
                            color: '#545454',
                            marginTop: (0, scale_1.scale)(4),
                        } }, `@${tweet?.userHandle}`)),
                react_1.default.createElement(react_native_1.View, { style: {
                        width: (0, scale_1.scale)(50),
                        alignItems: 'flex-end',
                        justifyContent: 'center',
                    } },
                    react_1.default.createElement(IconThreeDoc_1.default, { data: tweet, uri: `${window.location.origin}/post?postId=${postId}`, displayTweet: (_data) => {
                            displayTweet();
                        }, firestorePath: firestorePath(), disabled: tweet?.isDeleted == 1 }))),
            tweet?.isDeleted == 1 ? (react_1.default.createElement(react_native_1.View, { style: {
                    borderBottomWidth: 1,
                    borderBottomColor: '#DDDDDD',
                    paddingBottom: (0, scale_1.scale)(12),
                } },
                react_1.default.createElement(react_native_1.View, { style: {
                        width: (0, scale_1.scale)(343),
                        paddingHorizontal: (0, scale_1.scale)(24),
                        paddingVertical: (0, scale_1.scale)(12),
                        borderWidth: 1,
                        borderColor: '#DDDDDD',
                        borderRadius: 3,
                        backgroundColor: '#EDEDED',
                        marginLeft: (0, scale_1.scale)(16),
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            color: '#292A33',
                        } }, "\u3059\u3067\u306B\u524A\u9664\u3055\u308C\u305F\u30B3\u30E1\u30F3\u30C8\u3067\u3059")),
                react_1.default.createElement(react_native_1.View, { style: {
                        flexDirection: 'row',
                        marginTop: (0, scale_1.scale)(12),
                        marginHorizontal: (0, scale_1.scale)(16),
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                            color: '#292A33',
                            fontSize: (0, scale_1.moderateScale)(12),
                            lineHeight: (0, scale_1.moderateScale)(18),
                        }, onPress: () => {
                            setVisibleLike(true);
                        } },
                        (0, helpler_1.formatNumber)(countLike),
                        react_1.default.createElement(CustomText_1.default, { style: {
                                color: '#545454',
                                fontWeight: '300',
                                fontSize: (0, scale_1.moderateScale)(12),
                            } }, "\u4EF6\u306E\u3044\u3044\u306D")),
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                            color: '#292A33',
                            fontSize: (0, scale_1.moderateScale)(12),
                            lineHeight: (0, scale_1.moderateScale)(18),
                            marginLeft: (0, scale_1.scale)(16),
                        } },
                        (0, helpler_1.formatNumber)(replies.length),
                        react_1.default.createElement(CustomText_1.default, { style: {
                                color: '#545454',
                                fontWeight: '300',
                                fontSize: (0, scale_1.moderateScale)(12),
                            } }, "\u4EF6\u306E\u30B3\u30E1\u30F3\u30C8"))))) : (hasAccessPermission ?
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_native_1.View, { style: { marginHorizontal: (0, scale_1.scale)(16) } },
                        react_1.default.createElement(Status_1.Status, { statusPost: tweet?.publicationRange })),
                    react_1.default.createElement(react_native_hyperlink_1.default, { onPress: (url) => react_native_1.Linking.openURL(url), linkStyle: {
                            color: '#06c',
                            textDecorationLine: 'underline',
                        } },
                        react_1.default.createElement(CustomText_1.default, { style: {
                                color: '#292A33',
                                fontSize: (0, scale_1.moderateScale)(15),
                                fontWeight: '300',
                                lineHeight: (0, scale_1.moderateScale)(23),
                                marginTop: (0, scale_1.scale)(8),
                                marginHorizontal: (0, scale_1.scale)(16),
                            } }, tweet?.content
                            .split(helpler_1.hashtagRegex)
                            .map((string, index) => {
                            if (string.match(helpler_1.hashtagRegex)) {
                                return (react_1.default.createElement(react_native_1.Text, { key: index, style: { color: '#007AFF' }, onPress: () => {
                                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                            screen: Routes_1.default.HASHTAG_DETAIL,
                                            params: {
                                                hashtag: string?.slice(1),
                                                typeScreen: 0,
                                                typeHashTag: 3,
                                            },
                                        });
                                    } }, string));
                            }
                            else {
                                return react_1.default.createElement(react_native_1.Text, { key: index }, string);
                            }
                        }))),
                    react_1.default.createElement(react_native_1.View, { style: {
                            width: '100%',
                            marginTop: (0, scale_1.scale)(8),
                            paddingLeft: (0, scale_1.scale)(16),
                        } },
                        react_1.default.createElement(ListImageItemDetail_1.default, { data: tweet?.images, type: "post" })),
                    tweet?.type == 3 && (react_1.default.createElement(react_native_1.TouchableOpacity, { style: { marginLeft: (0, scale_1.scale)(18), marginTop: (0, scale_1.scale)(8) }, onPress: () => {
                            if (firestorePath() != 'tweets') {
                                return (0, rootNavigation_1.push)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                                    postId: idQuote,
                                    firestorePath: pathQuote,
                                });
                            }
                            (0, rootNavigation_1.push)(Routes_1.default.HOME_ARTICLE_DETAIL, {
                                postId: idQuote,
                                firestorePath: 'tweets',
                            });
                        } },
                        react_1.default.createElement(QuoteTweet_1.default, { data: dataquoteTweetPadh, type: 'DETAIL' }))),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            color: '#7C7C7C',
                            fontSize: (0, scale_1.moderateScale)(10),
                            fontWeight: '300',
                            lineHeight: (0, scale_1.moderateScale)(17),
                            marginTop: (0, scale_1.scale)(8),
                            marginHorizontal: (0, scale_1.scale)(16),
                        } }, `${(0, moment_1.default)(tweet?.createdAt).format('YYYY/MM/DD H:mm')}${tweet?.isEdited ? '(編集済み)' : ''}`),
                    react_1.default.createElement(react_native_1.View, { style: {
                            flexDirection: 'row',
                            marginTop: (0, scale_1.scale)(12),
                            marginHorizontal: (0, scale_1.scale)(16),
                        } },
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                                color: '#292A33',
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                            } },
                            (0, helpler_1.formatNumber)(replies.length),
                            react_1.default.createElement(CustomText_1.default, { style: {
                                    color: '#545454',
                                    fontWeight: '300',
                                    fontSize: (0, scale_1.moderateScale)(12),
                                } }, "\u4EF6\u306E\u30B3\u30E1\u30F3\u30C8")),
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                                color: '#292A33',
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                marginLeft: (0, scale_1.scale)(14),
                            }, onPress: () => {
                                setVisibleLike(true);
                            } },
                            (0, helpler_1.formatNumber)(countLike),
                            react_1.default.createElement(CustomText_1.default, { style: {
                                    color: '#545454',
                                    fontWeight: '300',
                                    fontSize: (0, scale_1.moderateScale)(12),
                                } }, "\u4EF6\u306E\u3044\u3044\u306D"))),
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.viewLike },
                        react_1.default.createElement(react_native_1.TouchableOpacity, { style: { marginRight: (0, scale_1.scale)(32) }, onPress: () => {
                                if (dataUser?.registration_status == 0) {
                                    return dispatch(slice_1.default.actions.showRequestLoginModal());
                                }
                                (0, rootNavigation_1.navigate)(Routes_1.default.REP_COMMENT, {
                                    data: `${(0, helpler_1.urlPost)(`${firestorePath()}/${idPostTweets()}`)}`,
                                    type: 'POST',
                                });
                            } },
                            react_1.default.createElement(IconComment_1.default, { color: mockData_1.dataDetail?.numberLikes > 0 ? '#44A06B' : '#545454', height: (0, scale_1.scale)(28) })),
                        react_1.default.createElement(IconRetweet_1.default, { idPost: idPostTweets(), data: tweet, dataTweet: tweet, height: (0, scale_1.scale)(28) }),
                        react_1.default.createElement(react_native_1.View, { style: { marginLeft: (0, scale_1.scale)(8) } },
                            react_1.default.createElement(IconLike_2.default, { idPost: idPostTweets(), height: (0, scale_1.scale)(28), callBack: (data) => {
                                    setCountLike(countLike + data);
                                } }))))
                :
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_native_1.View, { style: { marginHorizontal: (0, scale_1.scale)(16) } },
                            react_1.default.createElement(Status_1.Status, { statusPost: tweet?.publicationRange })),
                        react_1.default.createElement(react_native_1.View, { style: {
                                width: (0, scale_1.scale)(343),
                                alignSelf: 'center',
                                paddingVertical: (0, scale_1.scale)(12),
                                paddingHorizontal: (0, scale_1.scale)(24),
                                borderWidth: (0, scale_1.scale)(1),
                                borderColor: '#DDDDDD',
                                borderRadius: (0, scale_1.scale)(3),
                                backgroundColor: '#EDEDED',
                                marginTop: (0, scale_1.scale)(8)
                            } },
                            react_1.default.createElement(CustomText_1.default, { style: {
                                    fontSize: (0, scale_1.moderateScale)(14),
                                    lineHeight: (0, scale_1.moderateScale)(21),
                                    color: '#292A33'
                                } }, `この投稿はフォロワー限定の投稿です。\n閲覧するには、投稿者をフォローしてください。`)),
                        react_1.default.createElement(components_1.LinearButton, { title: '\u30D5\u30A9\u30ED\u30FC', containerStyle: {
                                marginTop: (0, scale_1.scale)(8),
                            }, style: {
                                width: (0, scale_1.scale)(343),
                                height: (0, scale_1.scale)(32),
                                borderRadius: (0, scale_1.scale)(4),
                                alignSelf: 'center'
                            }, textStyle: {
                                fontSize: (0, scale_1.moderateScale)(14),
                                lineHeight: (0, scale_1.moderateScale)(21),
                                color: '#FEFEFE'
                            }, onPress: handleFollowUser }),
                        react_1.default.createElement(CustomText_1.default, { style: {
                                color: '#7C7C7C',
                                fontSize: (0, scale_1.moderateScale)(10),
                                fontWeight: '300',
                                lineHeight: (0, scale_1.moderateScale)(17),
                                marginTop: (0, scale_1.scale)(8),
                                marginHorizontal: (0, scale_1.scale)(16),
                            } }, `${(0, moment_1.default)(tweet?.createdAt).format('YYYY/MM/DD H:mm')}${tweet?.isEdited ? '(編集済み)' : ''}`),
                        react_1.default.createElement(react_native_1.View, { style: {
                                flexDirection: 'row',
                                marginTop: (0, scale_1.scale)(12),
                                marginHorizontal: (0, scale_1.scale)(16),
                            } },
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                                    color: '#292A33',
                                    fontSize: (0, scale_1.moderateScale)(12),
                                    lineHeight: (0, scale_1.moderateScale)(18),
                                } },
                                (0, helpler_1.formatNumber)(replies.length),
                                react_1.default.createElement(CustomText_1.default, { style: {
                                        color: '#545454',
                                        fontWeight: '300',
                                        fontSize: (0, scale_1.moderateScale)(12),
                                    } }, "\u4EF6\u306E\u30B3\u30E1\u30F3\u30C8")),
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                                    color: '#292A33',
                                    fontSize: (0, scale_1.moderateScale)(12),
                                    lineHeight: (0, scale_1.moderateScale)(18),
                                    marginLeft: (0, scale_1.scale)(14),
                                }, onPress: () => {
                                    setVisibleLike(true);
                                } },
                                (0, helpler_1.formatNumber)(countLike),
                                react_1.default.createElement(CustomText_1.default, { style: {
                                        color: '#545454',
                                        fontWeight: '300',
                                        fontSize: (0, scale_1.moderateScale)(12),
                                    } }, "\u4EF6\u306E\u3044\u3044\u306D"))),
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.viewLike },
                            react_1.default.createElement(react_native_1.View, { style: { marginRight: (0, scale_1.scale)(32) } },
                                react_1.default.createElement(IconComment_1.default, { color: mockData_1.dataDetail?.numberLikes > 0 ? '#44A06B' : '#545454', height: (0, scale_1.scale)(28) })),
                            react_1.default.createElement(IconReset_1.default, { color: '#545454', height: (0, scale_1.scale)(28) }),
                            react_1.default.createElement(react_native_1.View, { style: {
                                    flexDirection: 'row',
                                    marginLeft: (0, scale_1.scale)(32),
                                    alignItems: 'center',
                                } },
                                react_1.default.createElement(IconLike_1.default, { color: '#545454', height: (0, scale_1.scale)(28) }))))),
            hasAccessPermission && (react_1.default.createElement(react_1.default.Fragment, null,
                replies.length == 0 && (react_1.default.createElement(CustomText_1.default, { style: {
                        marginTop: (0, scale_1.scale)(24),
                        width: '100%',
                        textAlign: 'center',
                        fontSize: (0, scale_1.moderateScale)(15),
                        color: '#292A33',
                    } })),
                replies.map((item) => (react_1.default.createElement(ItemUser_1.default, { data: item, key: item?._id, firestorePath: !!firestorePath()
                        ? `${firestorePath()}/${idPostTweets()}/replies`
                        : `tweets/${idPostTweets()}/replies`, idTweet: item?._id, disableShowMore: true }))))))) : (react_1.default.createElement(LinkErrorScreen_1.default, null))),
        react_1.default.createElement(ModalHistoryLike_1.default, { visible: visibleLike, onClose: () => setVisibleLike(false), label: `${(0, helpler_1.formatNumber)(countLike || 0)}件のいいね`, onSelect: () => { }, tweetId: idPostTweets() || '' }),
        react_1.default.createElement(ModalSuccess_1.default, { visible: visibleModalSuccess, onClose: () => setVisibleModalSuccess(false), content: "\u30B3\u30E1\u30F3\u30C8\u3057\u307E\u3057\u305F" }),
        react_1.default.createElement(ModalShare_1.default, { visible: visibleModal, onClose: () => setVisibleModal(false) }),
        react_1.default.createElement(ModalReportReason_1.default, { visible: visibleReport, onClose: () => setVisibleReport(false), onNext: () => {
                setVisibleReport(false);
                setIsAlert(true);
            } }),
        react_1.default.createElement(ModalReportSuccess_1.default, { visible: isAlert, onClose: () => {
                setIsAlert(false);
            }, title: "\u3054\u5831\u544A\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059", textFirst: "\u5F53\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u5B89\u5168\u3068\u5FEB\u9069\u6027\u3092\u4FDD\u3064\u305F\u3081\u306B\u3054\u5354\u529B\u3044\u305F\u3060\u304D\u3001\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002", textSecond: "\u79C1\u305F\u3061\u306E\u30C1\u30FC\u30E0\u304C\u901A\u5831\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3001\u5FC5\u8981\u306A\u5BFE\u5FDC\u3092\u884C\u3044\u307E\u3059\u3002", textThirs: "\u3053\u306E\u30D7\u30ED\u30BB\u30B9\u306B\u306F\u6570\u65E5\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u3054\u7406\u89E3\u304F\u3060\u3055\u3044\u3002", textFour: "\u901A\u5831\u306B\u95A2\u3057\u3066\u3055\u3089\u306A\u308B\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u304C\u5FC5\u8981\u306A\u5834\u5408\u3001\u307E\u305F\u306F\u72B6\u6CC1\u304C\u5909\u5316\u3057\u305F\u5834\u5408\u306F\u3001\u3044\u3064\u3067\u3082\u30B5\u30DD\u30FC\u30C8\u30C1\u30FC\u30E0\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002", textFive: "" })));
};
exports.default = DetailHomeScreen;
